{
  "alert": "تنبيه",
  "dismiss": "تجاهل"
}
